const PAYMENT_IS_PROCESSING = 'Thank you, your payment is processing';
const SUBSCRIPTION_COMPLETED = 'Subscription plan has been successfully completed';
const LOCKED_FIELD = 'This field has been locked for editing';
const TRIAL_ACTIVATED = 'Activating your trial';
export {
  PAYMENT_IS_PROCESSING,
  SUBSCRIPTION_COMPLETED,
  LOCKED_FIELD,
  TRIAL_ACTIVATED,
};
